import { DatePicker } from 'iqvia-shared/components';
import { Field } from 'redux-form';
import React from 'react';

const DateObjectField = ({ name, label, onChange, readonlyForm }) => (
  <Field
    name={`${name}`}
    component={DatePicker}
    label={label}
    disabled={readonlyForm}
    onChange={(_, value) => onChange(value)}
  />
);

DateObjectField.displayName = 'DateObjectField';

export default DateObjectField;



// WEBPACK FOOTER //
// ./src/JourneyBuilder/DecisionSplit/components/Path/PathObjectFields/DateObjectField.js